module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"sendTo":"CC","coBorrower":"Co-borrower","warrantor":"Warrantor","thirdParty":"Third party"},"et":{"sendTo":"CC","coBorrower":"Co-borrower","warrantor":"Warrantor","thirdParty":"Third party"},"ru":{"sendTo":"CC","coBorrower":"Созаемщик","warrantor":"Поручитель","thirdParty":"Треть лицо"}}')
  delete Component.options._Ctor
}
